var deviceFeaturesPage = (function () {
  var doc_sidebar = document.getElementById("device-features-sidebar-container"),
    getOffset = doc_sidebar.offsetTop,
    scrollAlong = {
      getOffset: function () {
        return getOffset;
      },
      /** Get Document height in Js
       * https://stackoverflow.com/questions/1145850/how-to-get-height-of-entire-document-with-javascript/44077777
       */
      getDocumentHeight: function () {
        var body = document.body,
          html = document.documentElement;
  
        var height = Math.max(
          body.scrollHeight,
          body.offsetHeight,
          html.clientHeight,
          html.scrollHeight,
          html.offsetHeight
        );
        return height;
      },
    };

  function init() {
    uiBindings();
  }

  function setOffset(offset) {
    getOffset = offset;
  }

  var uiBindings = function () {
    window.addEventListener("load", getSidebar);
    window.addEventListener("scroll", getSidebar);
  
    function getSidebar() {
      if (
        window.pageYOffset >
        scrollAlong.getDocumentHeight() -
          (document.getElementById("footer-habitat").offsetHeight +
            document.querySelector(".device-feature-footer-cta").offsetHeight) -
          84 -
          doc_sidebar.scrollHeight
      ) {
        doc_sidebar.classList.remove("bs-no-stick");
        doc_sidebar.classList.add("bs-stick-bottom");
      } else {
        // If window scroll is not on the footer
        if (doc_sidebar.classList.contains("bs-stick-bottom")) {
          doc_sidebar.classList.remove("bs-stick-bottom");
          if (!doc_sidebar.classList.contains("bs-stick-top")) {
            doc_sidebar.classList.add("bs-no-stick");
          }
        }
      }
      var element = document.querySelector(".device-features-template");
      if (window.pageYOffset > element.offsetTop) {
        if (!doc_sidebar.classList.contains("bs-stick-top")) {
          // Avoid flickering by adding sticky class only once.
          doc_sidebar.classList.remove("bs-no-stick");
          doc_sidebar.classList.add("bs-stick-top");
        }
      } else {
        doc_sidebar.classList.remove("bs-stick-top");
        doc_sidebar.classList.add("bs-no-stick");
      }
    }
    return scrollAlong;
  };

  return {
    init: init,
    setOffset: setOffset
  };
})();

/**
 *** Remove ChildNodes from Parent function
*/
function removeAllChildNodes(parent) {
  while (parent.firstChild) {
    parent.removeChild(parent.firstChild);
  }
}

/**
 *** device features sidebar list functionality
*/
function fetchDeviceFeaturesSideBarList(tabName) {
  var deviceFeaturesHeadings = document.querySelectorAll(
    ".device-features-template__info-section[data-target='" + tabName + "'] .device-features-template__info-header > h3"
  ),
    deviceFeaturesList = document.getElementById("side-nav");
  
  if (tabName) {
    removeAllChildNodes(deviceFeaturesList); // remove childnodes and events binded to it
    for (var i = 0; i < deviceFeaturesHeadings.length; i++) {
      var headingText = deviceFeaturesHeadings[i].textContent,
        headingTrigger = deviceFeaturesHeadings[i].getAttribute("data-trigger"),
        headingBadge = deviceFeaturesHeadings[i].getAttribute("data-badge");

      var headingItems =
        '<li data-link="#' + headingTrigger + '" class=""><a href="#' + headingTrigger + '"><span>' + headingText + '</span>';

      if (headingBadge) {
        headingItems += '<span class="device-features-badge">' + headingBadge + '</span>';
      }
      headingItems += "</a></li>";

      deviceFeaturesList.innerHTML += headingItems;
    }
    
    // Amplitude events on sidebar category list
    var dFSideBarListLinks = document.querySelectorAll('#side-nav li a');
    if (dFSideBarListLinks.length !== 0) {
      for (var t = 0; t < dFSideBarListLinks.length; t++) {
        dFSideBarListLinks[t].addEventListener("click", function() {
          var getSideBarElem = this.childNodes[0],
            getSideBarElemName = getSideBarElem ? getSideBarElem.innerText.replace(/\s/g, "") : 'SideBarLink';
        
          WebEventTracker.logEvent(EDS.webEvents, "InteractedWithDeviceFeaturesSummaryPage", {
            'product': activeProductTabName,
            'action': 'ClickedOn' + getSideBarElemName
          });
        });
      }
    }
  }
}

/**
 *** device features navbar sticky functionality
*/
var deviceFeaturesNav = document.getElementById("device-features-navbar");

if (deviceFeaturesNav) {
  var promoBar = document.getElementById('promo-notification'),
    stickyTop = deviceFeaturesNav.offsetTop;

  window.addEventListener(
    "scroll",
    function(e) {      
      if (window.pageYOffset >= stickyTop + (promoBar ? promoBar.offsetHeight : 0)) {
        deviceFeaturesNav.classList.add("nav-sticky-header");
      } else {
        deviceFeaturesNav.classList.remove("nav-sticky-header");
      }
    },
    false
  );
}

/**
 *** https://www.cssscript.com/easy-one-page-scroll-navigation-library-slide-nav/
*/
function activateScrollNavFn() {
  window.slide = new SlideNav({
    activeClass: "active",
    speed: 75,
    changeHash: true,
  });
}

/**
 *** device features Tab Header switch functionality
*/
var deviceFeatComponentTabs = document.querySelectorAll('.device-features-panel__list-item[role="tab"]'),
  deviceFeatContentPanel = document.querySelectorAll('.device-features-template__info-section[role="tabpanel"]'),
  activeProductTabName = '';

if (deviceFeatComponentTabs.length && deviceFeatContentPanel.length) {
  var getURLParam = window.location.hash,
    getActiveTabNameOnLoad = deviceFeatComponentTabs[0].getAttribute('data-tabname');
  
  if (getURLParam) {
    var getProductTabName = window.location.hash.split('#')[1],
      getActiveTabElem = document.querySelector('.device-features-panel__list-item[data-tabname="' + getProductTabName + '"]'),
      getActiveSectionElem = document.querySelector('.device-features-template__info-section[data-target="' + getProductTabName + '"]');
    
    if (getActiveTabElem && getActiveSectionElem) {
      if (getProductTabName === getActiveTabElem.getAttribute('data-tabname')) {
        getActiveTabElem.parentElement.classList.add('device-features-panel__list--active');
        getActiveTabElem.setAttribute('aria-selected', 'true');
        getActiveTabElem.removeAttribute('tabindex');
        hideAllDfTabContent(); // hide all DF content
        getActiveSectionElem.setAttribute('aria-hidden', 'false');
        getActiveSectionElem.parentElement.classList.remove('hide');
        fetchDeviceFeaturesSideBarList(getProductTabName);
        activateScrollNavFn();
        setSideBarListHeight(); // calculate sidebar height
        getActiveTabNameOnLoad = getProductTabName;
      }
    } else {
      deviceFeatComponentTabs[0].parentElement.classList.add('device-features-panel__list--active');
      deviceFeatComponentTabs[0].setAttribute('aria-selected', 'true');
      deviceFeatComponentTabs[0].removeAttribute('tabindex');
      hideAllDfTabContent(); // hide all DF content
      deviceFeatContentPanel[0].parentElement.classList.remove('hide');
      deviceFeatContentPanel[0].setAttribute('aria-hidden', 'false');
      fetchDeviceFeaturesSideBarList(getActiveTabNameOnLoad);
      activateScrollNavFn();
      setSideBarListHeight(); // calculate sidebar height
    }
  } else {
    deviceFeatComponentTabs[0].parentElement.classList.add('device-features-panel__list--active');
    deviceFeatComponentTabs[0].setAttribute('aria-selected', 'true');
    deviceFeatComponentTabs[0].removeAttribute('tabindex');
    hideAllDfTabContent(); // hide all DF content
    deviceFeatContentPanel[0].parentElement.classList.remove('hide');
    deviceFeatContentPanel[0].setAttribute('aria-hidden', 'false');
    fetchDeviceFeaturesSideBarList(getActiveTabNameOnLoad);
    activateScrollNavFn();
    setSideBarListHeight(); // calculate sidebar height
  }

  //active tab name
  activeProductTabName = getActiveTabNameOnLoad; 

  // For easy reference
  var keys = {
    end: 35,
    home: 36,
    left: 37,
    up: 38,
    right: 39,
    down: 40,
    delete: 46,
    enter: 13,
    space: 32,
  };

  // Add or subtract depending on key pressed
  var direction = {
    37: -1,
    38: -1,
    39: 1,
    40: 1,
  };

  // Bind listeners for product component
  for (var i = 0; i < deviceFeatComponentTabs.length; ++i) {
    setEventsOnDfComponentTabs(i);
  }

  function setEventsOnDfComponentTabs(index) {
    deviceFeatComponentTabs[index].addEventListener('click', setClickEvtOnDfComponentTab);
    deviceFeatComponentTabs[index].addEventListener('keydown', setKeydownEvtOnDfComponentTab);
    deviceFeatComponentTabs[index].addEventListener('keyup', setKeyupEvtOnDfComponentTab);

    // Build an array with all tabs (<button>s) in it
    deviceFeatComponentTabs[index].index = index;
  }

  // When a tab is clicked, activateTab is fired to activate it
  function setClickEvtOnDfComponentTab(event) {
    var tab = event.target;
    activateDfComponentTab(tab, false);
  }

  // Handle keydown on Product tabs
  function setKeydownEvtOnDfComponentTab(event) {
    var key = event.keyCode;

    switch (key) {
      case keys.end:
        event.preventDefault();
        // Activate last tab
        focusDfComponentLastTab();
        break;
      case keys.home:
        event.preventDefault();
        // Activate first tab
        focusDfComponentFirstTab();
        break;
      default:
    }
  }

  // Handle keyup on Product tabs
  function setKeyupEvtOnDfComponentTab(event) {
    var key = event.keyCode;

    switch (key) {
      case keys.left:
      case keys.right:
        switchDfTabOnArrowPress(event);
        break;
      case keys.enter:
      case keys.space:
        activateDfComponentTab(event.target);
        break;
      default:
    }
  }

  // Either focus the next, previous, first, or last tab
  // depending on key pressed
  function switchDfTabOnArrowPress(event) {
    var pressed = event.keyCode;
    if (direction[pressed]) {
      var target = event.target;
      if (target.index !== undefined) {
        if (deviceFeatComponentTabs[target.index + direction[pressed]]) {
          deviceFeatComponentTabs[target.index + direction[pressed]].focus();
        } else if (pressed === keys.left || pressed === keys.up) {
          focusDfComponentLastTab();
        } else if (pressed === keys.right || pressed == keys.down) {
          focusDfComponentFirstTab();
        }
      }
    }
  }

  // Activates any given tab panel
  function activateDfComponentTab(tab, setFocus) {
    setFocus = setFocus || true;                   

    // Deactivate all other tabs
    deactivateDfComponentTabs();

    // Remove tabindex attribute
    tab.removeAttribute('tabindex');

    // Set the tab as selected
    tab.setAttribute('aria-selected', 'true');

    //set active to parent element
    tab.parentElement.classList.add('device-features-panel__list--active');

    // Get the value of aria-controls (which is an ID)
    var panelControl = tab.getAttribute('aria-controls'),
      panelControlDom = document.getElementById(panelControl);  // Remove hidden attribute from product panel to make it visible

    if (panelControlDom) {
      panelControlDom.setAttribute('aria-hidden', 'false');
      panelControlDom.parentElement.classList.remove('hide');
    }

    //show images from lazy load
    lazyLoading.show();

    // Set focus when required
    if (setFocus) {
      tab.focus();
    }

    var tabName = tab.getAttribute('data-tabname');
    activeProductTabName = tabName; //active tab name

    // set sideBar List
    fetchDeviceFeaturesSideBarList(tabName);
    activateScrollNavFn();
    setSideBarListHeight(); // calculate sidebar height

    // Set URL for active state
    window.history.pushState(
      {path: window.location.href},
      "",
      '#' + tabName + ''
    );

    // Fire Amplitude Event on Tab click
    var getDFTabTitle = tab.getAttribute('title').replace(/\s/g, "");
    WebEventTracker.logEvent(EDS.webEvents, "InteractedWithDeviceFeaturesSummaryPage", {
      'product': activeProductTabName,
      'action': 'ClickedOn' + getDFTabTitle + 'Tab'
    });

    //scroll to top on tab switch
    var mainDFWrapper = document.getElementById('deviceFeaturesMainWrapper'),
      offsetTop = mainDFWrapper ? mainDFWrapper.offsetTop + 10 : 0;

    offsetTop = (window.innerWidth < 980) ? offsetTop - 8 : offsetTop; // for mobile devices add extra buffer
    window.scrollTo(0, offsetTop);
  }

  // Deactivate all tabs and tab panels
  function deactivateDfComponentTabs() {
    for (var j = 0; j < deviceFeatComponentTabs.length; j++) {
      deviceFeatComponentTabs[j].setAttribute('tabindex', '-1');
      deviceFeatComponentTabs[j].setAttribute('aria-selected', 'false');
      deviceFeatComponentTabs[j].parentElement.classList.remove('device-features-panel__list--active');
    }

    for (var k = 0; k < deviceFeatContentPanel.length; k++) {
      deviceFeatContentPanel[k].setAttribute('aria-hidden', 'true');
      deviceFeatContentPanel[k].parentElement.classList.add('hide');
    }
  }

  // Make a guess
  function focusDfComponentFirstTab() {
    deviceFeatComponentTabs[0].focus();
  }

  // Make a guess
  function focusDfComponentLastTab() {
    deviceFeatComponentTabs[deviceFeatComponentTabs.length - 1].focus();
  }

  // hide all DF content
  function hideAllDfTabContent() {
    for (var k = 0; k < deviceFeatContentPanel.length; k++) {
      deviceFeatContentPanel[k].setAttribute('aria-hidden', 'true');
      deviceFeatContentPanel[k].parentElement.classList.add('hide');
    }
  }
}

/**
 *** Amplitude Events binding for Elem
*/
var dFGetStartedBannerCTA = document.querySelector('.df-get-started-banner-cta'),
  dFSideBarCTABtn = document.querySelector('.device-features-template__sidebar-note-cta'),
  dFContentDocumentLink = document.querySelectorAll('.device-features-template__info-table-row-link-box > a');

if (dFGetStartedBannerCTA) {
  dFGetStartedBannerCTA.addEventListener('click', function() {
    WebEventTracker.logEvent(EDS.webEvents, "InteractedWithDeviceFeaturesSummaryPage", {
      'product': activeProductTabName,
      'action': 'ClickedOnMainGetStartedFree'
    });
  });
}

if (dFSideBarCTABtn) {
  dFSideBarCTABtn.addEventListener('click', function() {
    WebEventTracker.logEvent(EDS.webEvents, "InteractedWithDeviceFeaturesSummaryPage", {
      'product': activeProductTabName,
      'action': 'ClickedOnGetStartedFree'
    });
  });
}

if (dFContentDocumentLink.length !== 0) {
  for (var i = 0; i < dFContentDocumentLink.length; i++) {
    dFContentDocumentLink[i].addEventListener("click", setEventsOnDFDocumentationLink);
  }
}

function setEventsOnDFDocumentationLink() {
  var getFeatureElem = this.closest('.device-features-template__info-table-row'),
    getFeatureName = getFeatureElem ? getFeatureElem.querySelector('.device-features-template__info-table-row-name').innerText : '';

  WebEventTracker.logEvent(EDS.webEvents, "InteractedWithDeviceFeaturesSummaryPage", {
    'product': activeProductTabName,
    'action': 'ClickedOnDocumentation',
    'feature': getFeatureName
  });
}


/**
 *** Calculate sideBar offset height for scroll
*/
function setSideBarListHeight() {
  var windowHeight = window.innerHeight,
    dFTabHeader = document.getElementById('device-features-navbar'),
    dFTabHeaderHeight = dFTabHeader ? dFTabHeader.offsetHeight : 0,
    dFSideBarHeading = document.querySelector('.device-features-template__sidebar-heading'),
    dFSideBarHeadingHeight = dFSideBarHeading ? dFSideBarHeading.offsetHeight : 0,
    dFSideBarNote = document.querySelector('.device-features-template__sidebar-note'),
    dFSideBarNoteHeight = dFSideBarNote ? dFSideBarNote.offsetHeight : 0,
    dFSideBarList = document.getElementById('side-nav'),
    totalHeight = dFTabHeaderHeight + dFSideBarHeadingHeight + dFSideBarNoteHeight,
    dFSideBarListHeight = dFSideBarList ? windowHeight - totalHeight : dFSideBarList.offsetHeight;

  dFSideBarList.removeAttribute('style');
  if (dFSideBarList.offsetHeight >= dFSideBarListHeight) {
    dFSideBarList.style.height = dFSideBarListHeight + 'px';
    dFSideBarList.style.overflowY = 'auto';
  } else {
    dFSideBarList.style.height = dFSideBarList.offsetHeight + 'px';
  }
}

/**
 *** DOMContentLoaded Event
*/
document.addEventListener("DOMContentLoaded", function () {
  var sidebarContainer = document.getElementById(
    "device-features-sidebar-container"
  );

  if (sidebarContainer) {
    deviceFeaturesPage.init();
    deviceFeaturesPage.setOffset(430);
  }

  // fire Amplitude events on Page Load with Active Tab
  setTimeout(function() {
    WebEventTracker.logEvent(EDS.webEvents, "OnDeviceFeaturesSummaryPage", {
      'product': getActiveTabNameOnLoad
    });
  }, 1500);

  window.addEventListener("resize", function () {
    if (sidebarContainer) {
      deviceFeaturesPage.setOffset(430);
      setSideBarListHeight(); // calculate sidebar height
    }
  });
});